










































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetDlyRecords} from "@/api/hd"
import {GetListByCode} from "@/api/configureDictionary"
import patDlyRecord from '../../../../../../components/patDlyRecord.vue'

@Component({
	components: {patDlyRecord}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	patDlyRecordShow = false
	patData:any = {}
	data: any = {}
	loading = false
	query: any = {
		date: '最近一个月',
		dates: []
	}
	dialysisModels = []
	columns = [
		{
			title: '日期',
			key: 'dlyDate'
		}, {
			title: '透析模式',
			key: 'dlyWay'
		},{
			title: '透析情况',
			key: 'dlyCondition'
		}, {
			title: '制定处方医生',
			key: 'recipeDoctor'
		},{
			title: '确认处方护士',
			key: 'confirmNurse'
		}, {
			width:370,
			title: '操作',
			key: 'creationTime',
			render: (h: any, params: any) => {
				const vm = this
				return h('div', [
					h('Button',{
						props:{
							type:'primary',
						},
						style:{
							marginRight:'5px'
						},
					},'血气分析补录'),
					h('Button',{
						props:{
							type:'primary',
						},
						style:{
							marginRight:'5px'
						},
						on:{
							click:() => {
								vm.jld(params.row)
							}
						}
					},'记录单'),
					h('Button',{
						props:{
							type:'primary',
						},
					},'记录单编辑'),
				])
			}
		},
	]

	created() {
		this.getSelects()
		const end = new Date();
		const start = new Date();
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		this.query.dates = [start, end]
		this.init()
	}
	jld(item:any){
		this.patData = {...item, patientName: this.patient.patientName, showNum: false}
		this.patDlyRecordShow = true
	}
	dateChange(val: string) {
		switch (val) {
			case '全部':
				this.query.dates = []
				this.init()
				break
			case '最近一周':
				this.setDate(7)
				break
			case '最近一个月':
				this.setDate(30)
				break
			case '最近半年':
				this.setDate(182)
				break
			case '最近一年':
				this.setDate(365)
				break
			case '最近三年':
				this.setDate(365 * 3)
				break
		}
	}

	setDate(days: number) {
		const end = new Date()
		let start = new Date()
		start.setTime(start.getTime() - 3600 * 1000 * days * 24);
		this.query.dates = [start, end]
		this.init()
	}

	async init() {
		this.loading = true
		let query: any = {
			PatientId: this.patient.id
		}
		if (this.query.dates[0]) {
			query['StartDate'] = this.formatDate(this.query.dates[0])
			query['EndDate'] = this.formatDate(this.query.dates[1])
		}
		if (this.query.DlyWay) {
			query['DlyWay'] = this.query.DlyWay
		}
		let res = await GetDlyRecords(query)
		this.data = res.objects
		this.loading = false
	}

	private async getSelects() {
		let res = await GetListByCode({input: '025'})
		this.dialysisModels = res
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisInfo/dialysisRecords/index.vue